import Link from "next/link";
import { extractInternalHref } from "@/lib/utils/extractInternalHref";
import type { ParagraphDarkHeroCta as ParagraphDarkHeroCtaData } from "@/lib/api/cms-catalog";
import type { ParagraphTranslations } from "../Paragraph.i18n";
import { HtmlText } from "../shared/HtmlText";
import styles from "./ParagraphDarkHeroCta.module.css";

/**
 * Layout 47 - `PARAGRAPH_DARK_HERO_CTA_LAYOUT`: dark hero CTA.
 *
 * Struktura:
 *   - Dark full-bleed bg (chrome dark) z subtle green glow top-right + dot pattern
 *   - Eyebrow (text_1, zielony uppercase)
 *   - H1 (name, bialy bold)
 *   - Lead (text, HTML, jasny szary)
 *   - Solid green pill CTA (button_name + button_url, opcjonalny)
 *
 * Typowo: sekcja kariery ("Dolacz do zespolu"), kontakt hero.
 */
export function ParagraphDarkHeroCta({
  paragraph,
  t: _t,
}: {
  paragraph: ParagraphDarkHeroCtaData;
  t: ParagraphTranslations;
}) {
  const {
    text_1: eyebrow,
    name: title,
    text: lead,
    button_name: ctaLabel,
    button_url: ctaUrl,
  } = paragraph;

  const hasEyebrow = eyebrow && eyebrow.trim() !== "";
  const hasLead = lead && lead.trim() !== "";
  const hasCta = ctaLabel && ctaLabel.trim() !== "" && ctaUrl && ctaUrl.trim() !== "";
  const ctaHref = hasCta ? extractInternalHref(ctaUrl) : null;

  return (
    <section className={styles.section}>
      <div className={styles.inner}>
        {hasEyebrow ? <p className={styles.eyebrow}>{eyebrow}</p> : null}
        {title ? <h2 className={styles.title}>{title}</h2> : null}
        {hasLead ? (
          <HtmlText html={lead} className={styles.lead} />
        ) : null}
        {hasCta ? (
          ctaHref !== null ? (
            <Link href={ctaHref} className={styles.ctaBtn}>
              {ctaLabel}
            </Link>
          ) : (
            <a href={ctaUrl} className={styles.ctaBtn}>
              {ctaLabel}
            </a>
          )
        ) : null}
      </div>
    </section>
  );
}
